<template>
  <div class="stripe-overlay-wrapper">
    <div class="stripe-skeleton-overlay" :class="{ 'fade-out': showForm }">
      <StripeSkeleton />
    </div>
    <div
      id="stripe-container"
      class="stripe-container"
      :class="{ 'stripe-ready': showForm }"
    >
      <!-- <h4 class="text-primaryText">Express checkout</h4> -->
      <div id="express-checkout-element" class="my-4"></div>
      <v-row
        v-if="expressCheckoutMethodsAvailable"
        no-gutters
        align="center"
        justify="center"
      >
        <v-col>
          <v-divider class="border-opacity-20"></v-divider>
        </v-col>
        <v-col cols="auto" class="px-2 text-center">
          <span class="text-h6 text--secondary">OR</span>
        </v-col>
        <v-col>
          <v-divider class="border-opacity-20"></v-divider>
        </v-col>
      </v-row>

      <!-- Stripe Link Authentication Element for email input -->
      <!-- 
      Stripe Link Authentication Element:
      Purpose: Collects the user's email address and enables Stripe Link functionality for faster checkout.
      Details: Mounted to #link-auth-element. Updates the component's email property on change.
    -->
      <!-- Email -->
      <div class="my-4" v-if="userInfo?.id">
        <h3 class="text-primaryText my-2">Your Info</h3>
        <v-sheet border rounded class="py-4 px-4">
          <h5 class="text-primaryText fontsize-14 font-weight-bold">Email</h5>
          <v-text-field
            type="text"
            density="compact"
            variant=""
            :value="email"
            readonly
            :rounded="1"
            class="stripe-input"
            hide-details="auto"
          ></v-text-field>
        </v-sheet>
      </div>

      <div v-else>
        <h3 class="text-primaryText my-2">Your Info</h3>
        <v-sheet border rounded class="pa-4">
          <!-- class="float-sm-right my-2 my-sm-0 mt-sm-2 mb-sm-n3" -->
          <div class="my-2 already-register-container">
            <span class="d-none d-sm-inline-block">Already registered?</span>
            <a href="#" class="ml-1 text-black" @click.prevent="emitOpenSign"
              >Click here to login
            </a>
          </div>
          <div ref="linkAuthElement" id="link-auth-element" class="my-1"></div>
          <v-checkbox
            v-model="subscribeToNewsletter"
            size="20"
            hide-details="auto"
            density="compact"
            label="Subscribe to our newsletter"
            color="primaryText"
            class="mr-4"
          >
          </v-checkbox>
        </v-sheet>
      </div>

      <!-- Stripe Shipping Address Element for collecting shipping address -->
      <!-- 
        Stripe Shipping Address Element:
        Purpose: Collects the user's shipping address, including name, phone, and address fields.
        Details: Mounted to #shipping-address-element. Configured for US addresses, split name fields, and phone validation.
        Emits 'change' events with address data when complete.
      -->
      <div class="my-4" style="min-height: unset" v-if="!isGiftCardProduct">
        <h3 class="text-primaryText my-2">Shipping Address</h3>
        <v-sheet border rounded class="pa-4">
          <div ref="shippingAddressElement" id="shipping-address-element"></div>
        </v-sheet>
      </div>

      <!-- Stripe Billing Address Element for collecting billing address -->
      <!-- 
        Stripe Billing Address Element:
        Purpose: Collects the user's billing address, similar to the shipping address element.
        Details: Mounted to #billing-address-element. Uses same config as shipping, but mode is 'billing'.
      -->
      <!-- <v-skeleton-loader
        class="boarder mb-2"
        v-if="stripeElementsLoading"
        type="text"
        width="100%"
      /> -->
      <div class="my-4" style="min-height: unset">
        <h3 class="text-primaryText my-2">Billing Address</h3>
        <v-sheet border rounded class="pa-4">
          <div
            ref="billingAddressElement"
            id="billing-address-element"
            class="mt-2"
          ></div>
        </v-sheet>
      </div>
      <h4 v-if="shippingAddress?.country == 'CA'" class="text-error mt-2 pa-2">
        Please note that our website does not collect duties and taxes on
        international orders. These charges are the responsibility of the
        recipient and are typically due upon delivery. The amount of duties and
        taxes charged will vary depending on the country of destination and the
        value of your order.
      </h4>
      <div class="my-4" v-show="totalAmount" style="min-height: unset">
        <!-- Stripe Payment Element for card/payment method input -->
        <!-- 
        Stripe Payment Element:
        Purpose: Collects payment method details (card, Apple Pay, Google Pay, etc.) in a unified UI.
        Details: Mounted to #payment-element. Configured with accordion layout and default billing details.
      -->
        <h3 ref="paymentElement" class="text-primaryText my-2">
          Payment Method
        </h3>
        <div id="payment-element"></div>
      </div>

      <!-- Estimated Shipping Methods selection -->
      <!-- 
        Estimated Shipping Methods:
        Purpose: Allows user to select a shipping method from available options.
        Details: Displays skeleton loader while loading, otherwise shows radio group of methods.
      -->
      <div class="mb-5 estimated-shipping-class" v-if="!isGiftCardProduct">
        <h3 class="text-primaryText my-2">Shipping Methods</h3>
        <v-sheet
          border
          rounded
          class="pa-4"
          :class="hasShippingAddressError ? 'border-error ' : ''"
        >
          <div
            v-if="!shippingAddressValid"
            :class="hasShippingAddressError ? 'text-error d-flex' : 'd-flex'"
          >
            <div class="d-inline-block">
              <v-icon :icon="mdiInformationOutline" size="24" class="mr-1" />
            </div>
            <div class="d-inline-block">
              Please enter a shipping address, including your full name and
              phone number
            </div>
          </div>

          <div v-else>
            <div v-if="validateShippingAddressLoading">
              <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
            </div>
            <div v-else>
              <AddressReviewComponent
                :avalaraAddressResponse="avalaraAddressResponse"
                @userSelectedAddress="userSelectedAddress"
              />
              <div v-if="isShippingOptionLoading">
                <v-skeleton-loader
                  type="list-item-two-line"
                ></v-skeleton-loader>
              </div>
              <div v-else>
                <div class="mt-9">Select your shipping method</div>

                <v-radio-group
                  v-if="
                    estimatedShippingOptions &&
                    estimatedShippingOptions.length > 0
                  "
                  ref="shippingMethods"
                  v-model="estimatedShipping"
                  hide-details
                >
                  <div class="d-flex flex-column">
                    <v-sheet
                      border
                      rounded
                      v-for="(method, index) in estimatedShippingOptions"
                      :key="index"
                      class="shipping-option mt-4 pa-3 cursor-pointer d-flex"
                      :class="[
                        { 'mt-5': index === 0 },
                        estimatedShipping?.methodCode === method.methodCode
                          ? 'text-primaryText selected-shipping'
                          : 'text-black',
                      ]"
                      @click="estimatedShipping = method"
                    >
                      <v-row
                        no-gutters
                        align="center"
                        justify="center"
                        class="align-center"
                      >
                        <v-col
                          cols="9"
                          sm="9"
                          class="text-center d-flex justify-start text-start"
                        >
                          <v-radio
                            class="checkout-radio flex-grow-0 mr-0.5"
                            :value="method"
                            :model-value="estimatedShipping"
                          >
                          </v-radio>
                          <span>{{ method.label }}</span>
                        </v-col>

                        <v-col
                          cols="3"
                          sm="3"
                          class="font-weight-400 text-center text-end"
                        >
                          ${{ priceFormatter(method.amount) }}
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </div>
                </v-radio-group>
                <div
                  v-else-if="!shippingAddress && avalaraAddressResponse?.error"
                  class="d-flex text-error mt-5"
                >
                  <div class="d-inline-block">
                    <v-icon
                      :icon="mdiInformationOutline"
                      size="24"
                      class="mr-1"
                    />
                  </div>
                  <div class="d-inline-block">
                    Your address is unrecognized.
                    <br />
                    Please provide a valid address or use your original address.
                  </div>
                </div>

                <div
                  v-if="
                    estimatedShippingOptions &&
                    estimatedShippingOptions.length == 1 &&
                    avalaraAddressResponse?.error
                  "
                  class="mt-8 d-flex warning"
                >
                  <div class="d-inline-block">
                    <v-icon
                      :icon="mdiInformationOutline"
                      size="24"
                      class="mr-1"
                    />
                  </div>
                  <div class="d-inline-block">
                    Your provided address is not recognized. We are unable to
                    provide expedited shipping options. Please double check your
                    address.
                    <br />
                    <br />
                    You may submit your order anyways if you feel that your
                    address is correct.
                  </div>
                </div>

                <div
                  v-else-if="shippingMethodWaring"
                  class="mt-8 d-flex warning"
                  :class="hasShippingAddressError ? 'text-error ' : ''"
                >
                  <div class="d-inline-block">
                    <v-icon
                      :icon="mdiInformationOutline"
                      size="24"
                      class="mr-1"
                    />
                  </div>
                  <div class="d-inline-block">
                    No expedited shipping methods are available for your
                    shipping address.
                    <br />
                    Please double check the address to confirm it is accurate.
                  </div>
                </div>

                <div
                  v-else-if="
                    shippingAddress && !estimatedShippingOptions?.length
                  "
                  class="mt-5 text-error d-flex"
                >
                  <div class="d-inline-block">
                    <v-icon
                      :icon="mdiInformationOutline"
                      size="24"
                      class="mr-1"
                    />
                  </div>
                  <div class="d-inline-block">
                    There are no shipping options for this address.
                    <br />
                    Please enter a different shipping address.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-sheet>
      </div>

      <div class="d-block d-md-none my-5">
        <div v-show="showStoreCredit">
          <!-- Divider between product list and totals -->
          <StoreCredit
            class="pa-3"
            :giftCardCreditBalance="giftCardCreditBalance"
            :isCheckoutProcessing="isCheckoutProcessing"
            :showStoreCredit="showStoreCredit"
            @useStoreCreditClick="handleUseStoreCreditClick"
          />
        </div>

        <CouponCode
          :isUser="isUser"
          :isCouponLoading="isCouponLoading"
          :discountGuestCode="discountGuestCode"
          :userDiscountCodeList="userDiscountCodeList"
          :isCheckoutProcessing="isCheckoutProcessing"
          @checkGuestCouponCode="checkGuestCouponCode"
          @removeGuestCouponCode="removeGuestCouponCode"
          @checkUserCouponCode="checkUserCouponCode"
          @removeUserCouponCode="removeUserCouponCode"
        />
      </div>

      <!-- Pay button with hover effect and loading state -->
      <!-- 
      Pay Button:
      Purpose: Initiates payment and order placement.
      Details: Shows loading state when processing, otherwise displays 'Pay'.
    -->

      <v-btn
        block
        size="x-large"
        color="primaryButton"
        class="rounded pa-6 text-white text-uppercase ls-0 font-weight-bold body productpage-button"
        @click="handlePayClick"
        :disabled="isCheckoutBusy"
        :loading="isCheckoutBusy"
      >
        {{
          totalAmount > 0
            ? `Pay $${formatAmount(totalAmount / 100)}`
            : "Place order"
        }}
      </v-btn>

      <!-- <template
            v-if="stripeElementsLoading || isShippingInformationSubmitting"
          >
          </template>
          <template v-else>
            <span> Pay ${{ totalAmount / 100 }}</span>
          </template> -->
      <!-- Snackbar for notifications -->
      <!-- 
      SnackbarComponent:
      Purpose: Displays notifications and error messages to the user.
      Details: Controlled via snackbar object in data.
    -->
      <SnackbarComponent :snackbar="snackbar"></SnackbarComponent>
    </div>
  </div>
</template>

<script>
import { getStripe } from "@/services/loadStripe";
import {
  doFetchEstimatedShippingMethods as doFetchUserEstimatedShippingMethods,
  doShippingInformation as doUserShippingInformation,
} from "@/services/user.service";
import {
  doFetchEstimatedShippingMethods as doFetchGuestEstimatedShippingMethods,
  doShippingInformation as doGuestShippingInformation,
} from "@/services/guest.service";
import { getMagentoRegionId } from "@/services/directory.service";
import {
  priceFormatter,
  transformContactsForStripe,
  debounce,
  datadogLogError,
  formatAmount,
} from "@/services/util.service";
import countries from "@/services/countries";
import SnackbarComponent from "@/components/common/SnackbarComponent.vue";
import StripeSkeleton from "@/components/crane/payment/StripeSkeleton.vue";
import CouponCode from "@/components/crane/cart-product/CouponCode.vue";
import StoreCredit from "@/components/crane/cart-product/StoreCredit.vue";
import { mdiInformationOutline } from "@mdi/js";
import AddressReviewComponent from "@/components/address/AddressReviewComponent.vue";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "stripeCheckout/getField",
  mutationType: "stripeCheckout/updateField",
});

export default {
  name: "StripeCheckout",
  props: [
    "userInfo",
    "estimatedShippingMethods",
    "checkoutProductTotalAmt",
    "isCheckoutProcessing",
    "isGiftCardProduct",

    // coupon code component props
    "discountGuestCode",
    "isCouponLoading",
    "isUser",
    "userDiscountCodeList",
    "avalaraAddressResponse",
    "storeCreditUsed",
    "giftCardCreditBalance",
  ],
  components: {
    SnackbarComponent,
    StripeSkeleton,
    CouponCode,
    AddressReviewComponent,
    StoreCredit,
  },
  data() {
    return {
      priceFormatter: priceFormatter, // Utility for formatting price
      elements: null, // Stripe Elements instance
      paymentElement: null, // Stripe Payment Element
      shippingAddressElement: null, // Stripe Shipping Address Element
      billingAddressElement: null, // Stripe Billing Address Element
      linkAuthElement: null, // Stripe Link Authentication Element
      expressCheckoutElement: null, // Stripe Express Checkout Element (unused in template)
      stripe: null, // Stripe instance
      estimatedShipping: "", // Selected shipping method
      readyCount: 0, // Counter for ready Stripe Elements
      totalElements: 4, // Total Stripe Elements to wait for
      stripeElementsLoading: false, // Loading state for Stripe Elements
      isSubmitting: false,
      snackbar: {
        show: false,
        message: null,
        color: null,
        timeout: 0,
      },
      email: "", // Stores user's email from Link Authentication Element
      phone: "",
      shippingContacts: [], // Transformed addresses for Stripe
      billingContacts: [], // Transformed addresses for Stripe
      totalAmount: 0,
      showForm: false,
      sameAsShipping: true,
      shippingAddress: {},
      estimatedShippingOptions: this.estimatedShippingMethods,
      expressCheckoutMethodsAvailable: false,
      stripeElementDefaultOptions: {
        // locale: "en",
        paymentMethodCreation: "manual",
        currency: "usd",
        appearance: {
          theme: "stripe",
          variables: {
            colorPrimary: "#0F162A",
            fontFamily: "Roboto, sans-serif",
            // // spacingUnit: "2px",
            // colorText: "red", // Changes all text to white

            // // You can also use a more specific variable if available
            // colorTextSecondary: "green", // For secondary text like placeholder
            // // See all possible variables below
          },
          rules: {
            ".Label": {
              color: "#0F162A",
              fontWeight: "bold",
              fontSize: "14px",
            },
          },
        },
        loader: "always",
      },
      stripeMode: "payment",
      subscribeToNewsletter: true,
      mdiInformationOutline,
      shippingAddressValid: false,
      hasShippingAddressError: false,
    };
  },
  computed: {
    ...mapFields([
      "isPaymentProcessing",
      "isShippingOptionLoading",
      "validateShippingAddressLoading",
      "clientSecret",
    ]),
    isCheckoutBusy() {
      return (
        this.isSubmitting ||
        this.stripeElementsLoading ||
        this.isCheckoutProcessing ||
        this.isPaymentProcessing ||
        this.validateShippingAddressLoading
      );
    },
    shippingMethodWaring() {
      if (this.estimatedShippingOptions?.length == 1) return true;
      else return false;
    },
    isStoreCreditUsed() {
      const val = Number(this.storeCreditUsed);
      return val !== 0;
    },
    showStoreCredit() {
      return (
        this.isUser &&
        Number(this.giftCardCreditBalance) > 0 &&
        !this.isStoreCreditUsed &&
        Number(this.checkoutProductTotalAmt?.grandTotal) > 0
      );
    },
  },
  watch: {
    isGiftCardProduct(newValue) {
      if (newValue == true) {
        this.loadBillingAddressElement(newValue);
        this.clearShippingAddressElement();
      } else {
        this.loadShippingAddressElement();
        this.clearBillingAddressElement();
        this.loadBillingAddressElement();
      }
    },
    // Watch for changes in shipping methods and reset selection
    estimatedShippingMethods(newValue) {
      this.hasShippingAddressError = false;
      this.estimatedShippingOptions = newValue ? newValue : [];
      // this.estimatedShipping = "";
      if (this.checkoutProductTotalAmt?.shippingAmount)
        this.estimatedShipping = this.estimatedShippingOptions.filter(
          (x) => x.amount == this.checkoutProductTotalAmt?.shippingAmount
        )[0];

      if (!this.estimatedShipping)
        this.estimatedShipping = newValue ? newValue[0] : null;

      // if (this.estimatedShipping)
      //   this.handleShippingMethodChange(this.estimatedShipping);
    },
    estimatedShipping(newValue, oldValue) {
      if (newValue == null || newValue === oldValue) return;
      this.handleShippingMethodChange(newValue);
    },
    // Watch for changes in product total amount and update Stripe Elements
    checkoutProductTotalAmt(newValue, oldValue) {
      // Log change for debugging
      console.log(
        `Prop 'message' changed from '${oldValue}' to '${newValue}'.`
      );
      let amount = Math.round(Number(newValue.grandTotal).toFixed(2) * 100);
      // Update Stripe Elements with new amount
      let intervalId = null;
      this.totalAmount = amount;
      if (this.totalAmount > 0) {
        intervalId = setInterval(async () => {
          if (this.elements) {
            this.elements.update({
              ...this.stripeElementDefaultOptions,
              mode: this.stripeMode,
              amount: this.totalAmount,
            });
            this.loadPaymentElement();
            clearInterval(intervalId);
          }
        }, 100); // poll every 2s
      } else {
        if (intervalId) clearInterval(intervalId);
        this.clearPaymentElement();
      }

      // this.$store.dispatch(
      //   "stripeCheckout/setShippingInformationSubmittingLoading",
      //   false
      // );
    },
    // isGiftCardProduct(newValue) {
    //   if (newValue === true) {
    //     this.loadBillingAddressElement(newValue);
    //     this.clearShippingAddressElement();
    //   }
    // },
  },
  async mounted() {
    /**
     * The mounted lifecycle hook is responsible for initializing Stripe and setting up all the required Stripe Elements.
     * This includes creating the payment, shipping address, billing address, and link authentication elements, and mounting them to their respective DOM nodes.
     * The code also sets up event listeners for readiness and changes, manages loading states, and debounces shipping address updates to avoid excessive API calls.
     * By handling all Stripe-related setup here, the component ensures that the payment form is fully interactive and responsive to user input.
     */

    this.stripe = await getStripe(); // ✅ shared singleton

    this.email = this.userInfo.email ? this.userInfo.email : "";
    if (this.userInfo.email) {
      const { shippingContacts, billingContacts } =
        await transformContactsForStripe({
          addresses: this.userInfo.addresses,
        });
      this.shippingContacts = shippingContacts;
      this.billingContacts = billingContacts;
    }

    this.totalAmount = Math.round(
      Number(this.checkoutProductTotalAmt.grandTotal).toFixed(2) * 100
    );

    // Create Stripe Elements instance

    if (this.totalAmount > 0) {
      this.elements = this.stripe.elements({
        ...this.stripeElementDefaultOptions,
        mode: this.stripeMode,
        amount: this.totalAmount,
      });
    } else {
      this.elements = this.stripe.elements({
        ...this.stripeElementDefaultOptions,
      });
    }

    // Create and mount Link Authentication Element for email
    /**
     * Stripe Link Authentication Element:
     * Purpose: Collects the user's email address and enables Stripe Link functionality for faster checkout.
     * Details: Configured with default email for demonstration. Mounted to #link-auth-element in the template.
     */
    if (!this.email) {
      // Mount the linkAuthentication element separately
      this.linkAuthElement = this.elements.create("linkAuthentication");
      this.linkAuthElement.mount("#link-auth-element");
      // Listen for changes in link authentication element (email)
      /**
       * Link Authentication Change Event:
       * Purpose: Updates email property when user changes email input.
       * Details: Stores email for use in payment and shipping address.
       */
      this.linkAuthElement.on("change", (event) => {
        if (event.complete && event.value.email) {
          this.email = event.value.email;
          console.log("Email from LinkAuthenticationElement:", this.email);
        }
      });
    }

    if (this.totalAmount > 0) {
      this.loadPaymentElement();
    }
    if (!this.isGiftCardProduct) this.loadShippingAddressElement();
    this.loadBillingAddressElement(this.isGiftCardProduct);

    // Express Checkout Element (not shown in template)
    /**
     * Stripe Express Checkout Element:
     * Purpose: Provides express checkout options (Apple Pay, Google Pay, PayPal, Klarna).
     * Details: Configured with button types for each provider. Mounted to #express-checkout-element (not in template).
     */
    // const expressCheckoutOptions = {
    //   business: {
    //     name: "CRANE",
    //   },
    //   paymentMethods: {
    //     googlePay: "always",
    //     // applePay: "always",
    //   },
    //   emailRequired: true,
    //   phoneNumberRequired: true,
    //   shippingAddressRequired: true,
    //   billingAddressRequired: true,
    //   allowedShippingCountries: ["US", "CA"],
    //   buttonType: {
    //     applePay: "buy",
    //     googlePay: "buy",
    //     paypal: "buynow",
    //     klarna: "pay",
    //   },
    // };
    // this.expressCheckoutElement = this.elements.create(
    //   "expressCheckout",
    //   expressCheckoutOptions
    // );
    // this.expressCheckoutElement.mount("#express-checkout-element");

    // Listen for Stripe Elements ready events to manage loading state
    /**
     * Stripe Elements Ready Events:
     * Purpose: Track when all Stripe Elements are loaded and ready.
     * Details: Increments readyCount for each element's 'ready' event, disables loading when all are ready.
     */
    [
      this.linkAuthElement,
      //   this.expressCheckoutElement,
      this.paymentElement,
      this.shippingAddressElement,
      this.billingAddressElement,
    ].forEach((el) => {
      if (el) {
        el.on("ready", ({ availablePaymentMethods }) => {
          if (el._componentName === "expressCheckout") {
            console.log("availablePaymentMethods", availablePaymentMethods);
            // if (availablePaymentMethods)
            //   this.expressCheckoutMethodsAvailable = true;
          }

          // Increment ready count and hide loading when all elements are ready
          this.readyCount++;
          if (this.readyCount === this.totalElements) {
            this.stripeElementsLoading = false;
            this.showForm = true;
          }
        });
      } else this.readyCount++;
    });

    // this.expressCheckoutElement.on("confirm", async (event) => {
    //   try {
    //     console.log("confirm event", event);
    //     let billingDetails = event.billingDetails;
    //     let shippingDetails = event.shippingAddress;
    //     let email = event.billingDetails.email;
    //     let shippingRate = event.shippingRate;
    //     let nameParts = shippingDetails.name?.split(" ");
    //     if (!nameParts)
    //       nameParts = [
    //         shippingDetails.address.firstname,
    //         shippingDetails.address.lastname,
    //       ];
    //     const { error, paymentMethod } = await this.stripe.createPaymentMethod({
    //       elements: this.elements,
    //     });
    //     if (error) {
    //       console.log("error in creating payment method", error);
    //       this.snackbar = {
    //         message: error,
    //         color: "error",
    //         show: true,
    //         timeout: 3000,
    //       };
    //       reject({
    //         error: {
    //           message: error?.message || "An unexpected error occurred",
    //         },
    //       });
    //     }
    //     if (paymentMethod) {
    //       this.$store.dispatch("stripeCheckout/setPaymentProcessing", true);
    //       let address = billingDetails.address;

    //       let countryData = countries[address.country];
    //       const region = countryData.available_regions.find(
    //         (r) => r.code.toUpperCase() === address.state.toUpperCase()
    //       );

    //       // let responseData = await getMagentoRegionId({
    //       //   countryCode: address.country,
    //       //   stateCode: address.state,
    //       // });
    //       // const region = responseData.available_regions.find(
    //       //   (r) => r.code.toUpperCase() === address.state.toUpperCase()
    //       // );

    //       let shippingAddress = {
    //         region: region,
    //         regionId: region.id,
    //         regionCode: region.code,
    //         countryId: shippingDetails.address.country,
    //         streetNoOne: shippingDetails.address.line1,
    //         streetNoTwo: shippingDetails.address.line2,
    //         street: [
    //           shippingDetails.address.line1,
    //           shippingDetails.address.line2,
    //         ],
    //         postcode: shippingDetails.address.postal_code,
    //         city: shippingDetails.address.city,
    //         firstname: nameParts[0] ? nameParts[0] : "",
    //         lastname: nameParts[1] ? nameParts[1] : "",
    //         telephone: billingDetails.phone,
    //       };
    //       let setShippingResponse;
    //       if (this.userInfo?.id) {
    //         setShippingResponse = await doUserShippingInformation(
    //           { email: email, id: this.userInfo?.id },
    //           shippingAddress,
    //           shippingRate,
    //           shippingAddress
    //         );
    //       } else {
    //         let guestQuoteId = this.$store.state.guestInfo.guestQuoteId;
    //         setShippingResponse = await doGuestShippingInformation(
    //           shippingAddress,
    //           shippingRate,
    //           email,
    //           guestQuoteId,
    //           shippingAddress
    //         );
    //       }

    //       this.$emit("processPayment", {
    //         paymentMethod: paymentMethod,
    //         billingDetails: paymentMethod.billing_details,
    //         email: email,
    //       });
    //       // this.$emit("handleExpressPaymentCompletion", {
    //       //   order,
    //       //   orderId,
    //       // });
    //       // try {
    //       //   let order;
    //       //   let orderId;

    //       //   if (this.userInfo?.id) {
    //       //     let processPaymentResponse = await this.$store.dispatch(
    //       //       "accountOne/processPayment",
    //       //       {
    //       //         email: email,
    //       //         billingDetails: billingDetails,
    //       //         paymentMethod: {
    //       //           method: "stripe_payments",
    //       //           additional_data: {
    //       //             payment_method: paymentMethod.id,
    //       //           },
    //       //         },
    //       //       }
    //       //     );
    //       //     // 3. Assign the properties from the result to the variables
    //       //     order = processPaymentResponse.order;
    //       //     orderId = processPaymentResponse.orderId;
    //       //     console.log("process order response:", orderId);
    //       //   } else {
    //       //     let processPaymentResponse = await this.$store.dispatch(
    //       //       "guestInfo/processPayment",
    //       //       {
    //       //         email: email,
    //       //         billingDetails: billingDetails,
    //       //         paymentMethod: {
    //       //           method: "stripe_payments",
    //       //           additional_data: {
    //       //             payment_method: paymentMethod.id,
    //       //           },
    //       //         },
    //       //       }
    //       //     );

    //       //     order = processPaymentResponse.order;
    //       //     orderId = processPaymentResponse.orderId;
    //       //     console.log("Place order response:", orderId);
    //       //   }
    //       //   this.$router.push({
    //       //     name: "OrderSuccess",
    //       //     params: { orderNumber: orderId },
    //       //   });
    //       //   this.$store.dispatch("stripeCheckout/setPaymentProcessing", false);
    //       //   console.log("orderId", orderId);

    //       //   // this.$emit("handleExpressPaymentCompletion", {
    //       //   //   order,
    //       //   //   orderId,
    //       //   // });
    //       // } catch (error) {
    //       //   console.log("error in placing order", error);
    //       //   this.snackbar = {
    //       //     message: error,
    //       //     color: "error",
    //       //     show: true,
    //       //     timeout: 3000,
    //       //   };
    //       // }
    //     }
    //   } catch (error) {
    //     console.log("error in creating payment method inside express", error);
    //     this.snackbar = {
    //       message: error,
    //       color: "error",
    //       show: true,
    //       timeout: 3000,
    //     };
    //   }
    // });

    // this.expressCheckoutElement.on("cancel", async (event) => {
    //   this.hasShippingMethodError = false;
    //   this.estimatedShipping = "";
    // });

    // this.expressCheckoutElement.on("shippingaddresschange", async (event) => {
    //   let resolve = event.resolve;
    //   let reject = event.reject;
    //   let address = event.address;
    //   try {
    //     console.log("address", address);
    //     let countryData = countries[address.country];
    //     const region = countryData.available_regions.find(
    //       (r) => r.code.toUpperCase() === address.state.toUpperCase()
    //     );
    //     console.log("region", region);
    //     this.shippingAddress = {
    //       region: region,
    //       regionId: region.id,
    //       regionCode: region.code,
    //       countryId: address.country,
    //       street: [],
    //       postcode: address.postal_code,
    //       city: address.city,
    //     };
    //     let shippMethods = null;
    //     if (this.userInfo?.id) {
    //       await this.$store.dispatch(
    //         "accountOne/setShippingDetails",
    //         this.shippingAddress
    //       );
    //       shippMethods = await doFetchUserEstimatedShippingMethods(
    //         {},
    //         this.shippingAddress
    //       );
    //     } else {
    //       let guestQuoteId = this.$store.state.guestInfo.guestQuoteId;
    //       shippMethods = await doFetchGuestEstimatedShippingMethods(
    //         this.shippingAddress,
    //         null,
    //         guestQuoteId
    //       );
    //     }

    //     console.log("shippMethods", shippMethods);
    //     let shippingRates = shippMethods.map((method) => {
    //       return {
    //         id: method.method_code, // region id must be in string for autofill suggestion
    //         displayName: method.carrier_title + "-" + method.method_title,
    //         methodCode: method.method_code,
    //         carrierCode: method.carrier_code,
    //         amount: Math.round(Number(method.amount) * 100),
    //       };
    //     });
    //     if (shippingRates.length == 1) {
    //       let setShippingResponse;
    //       if (this.userInfo?.id) {
    //         setShippingResponse = await doUserShippingInformation(
    //           {},
    //           this.shippingAddress,
    //           shippingRates[0],
    //           this.shippingAddress
    //         );
    //       } else {
    //         let guestQuoteId = this.$store.state.guestInfo.guestQuoteId;
    //         setShippingResponse = await doGuestShippingInformation(
    //           this.shippingAddress,
    //           shippingRates[0],
    //           null,
    //           guestQuoteId,
    //           this.shippingAddress
    //         );
    //       }

    //       let amount = Math.round(
    //         Number(setShippingResponse.totals.base_grand_total) * 100
    //       );
    //       // Update Stripe Elements with new amount
    //       this.totalAmount = amount;
    //       this.elements.update({ amount: amount });
    //     }
    //     // define payload and pass it into resolve
    //     let payload = {
    //       shippingRates: shippingRates,
    //       shippingRate: null,
    //     };
    //     // call event.resolve within 20 seconds
    //     resolve(payload);
    //   } catch (error) {
    //     console.log("error in shiping address", error);
    //     reject();
    //   }
    // });

    // this.expressCheckoutElement.on("shippingratechange", async (event) => {
    //   let resolve = event.resolve;
    //   let reject = event.reject;
    //   let shippingRate = event.shippingRate;
    //   // handle shippingratechange event
    //   try {
    //     let address = this.shippingAddress;

    //     let setShippingResponse;
    //     if (this.userInfo?.id) {
    //       setShippingResponse = await doUserShippingInformation(
    //         {},
    //         address,
    //         shippingRate,
    //         address
    //       );
    //     } else {
    //       let guestQuoteId = this.$store.state.guestInfo.guestQuoteId;
    //       setShippingResponse = await doGuestShippingInformation(
    //         address,
    //         shippingRate,
    //         null,
    //         guestQuoteId,
    //         address
    //       );
    //     }

    //     let amount = Math.round(
    //       Number(setShippingResponse.totals.base_grand_total) * 100
    //     );
    //     // Update Stripe Elements with new amount
    //     this.totalAmount = amount;
    //     this.elements.update({ amount: amount });
    //     // call event.resolve within 20 seconds
    //     resolve();
    //   } catch (error) {
    //     console.log("error in shiping method selection", error);
    //     reject();
    //   }
    // });
  },
  methods: {
    formatAmount,
    // Handle order placement and Stripe payment method creation
    /**
     * processPayment:
     * Purpose: Validates Stripe Elements, creates payment method, and emits order data to parent.
     * Details: Shows error in snackbar if validation fails, otherwise emits payment method and billing details.
     */
    async handlePayClick() {
      try {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        this.hasShippingAddressError = false;
        let billingInfo;
        let shippingInfo;
        if (this.billingAddressElement) {
          billingInfo = await this.billingAddressElement.getValue();
          console.log("billing info", billingInfo);
        }

        if (this.shippingAddressElement) {
          shippingInfo = await this.shippingAddressElement.getValue();
          console.log("shippingInfo info", shippingInfo);
        }

        if (this.isGiftCardProduct) {
          shippingInfo = billingInfo;
        }
        // Submit Stripe Elements for validation
        const { error: submitError } = await this.elements.submit();

        if (!this.isGiftCardProduct && !this.estimatedShipping)
          this.hasShippingAddressError = true;

        if (submitError) {
          await this.scrollToError(submitError.code);

          // Show error in snackbar
          this.snackbar = {
            message: submitError.message,
            color: "error",
            show: true,
            timeout: 3000,
          };
          console.log("error in element submit", submitError);
          return;
        } else if (!this.isGiftCardProduct && !this.estimatedShipping) {
          this.snackbar = {
            message: "Shipping method not selected",
            color: "error",
            show: true,
            timeout: 3000,
          };
          console.log("error in element submit", submitError);
          await this.scrollToError("incomplete_shipping_method");
          return;
        } else {
          //this.hasShippingMethodError = false;
        }

        // Create Stripe payment method
        /**
         * Attempts to create a Stripe payment method using the provided elements.
         * Emits a "processPayment" event with the payment method, billing details, and user email if successful.
         * Handles and logs errors during payment method creation.
         *
         * Workflow:
         * 1. Calls Stripe's createPaymentMethod with the current elements.
         * 2. If an error occurs, logs the error to the console.
         * 3. If a payment method is created successfully, emits a "processPayment" event with relevant details.
         * 4. Catches and logs any unexpected errors during the process.
         *
         * @async
         * @returns {void}
         * @emits processPayment - Contains paymentMethod, billingDetails, and email.
         */
        try {
          if (this.totalAmount > 0) {
            const { error, paymentMethod } = await this.getPaymentMethod();
            if (error) {
              console.log("error in creating payment method", error);
              if (error.includes("card"))
                await this.scrollToError("incomplete_number");
              this.snackbar = {
                message: error,
                color: "error",
                show: true,
                timeout: 3000,
              };
            }
            if (paymentMethod) {
              this.$emit("processPayment", {
                paymentMethod: paymentMethod,
                paymentMethodType: "stripe_payments",
                billingDetails: {
                  ...paymentMethod.billing_details,
                  phone: shippingInfo.value.phone,
                },
                email: this.email,
              });
            }
          } else {
            this.$emit("processPayment", {
              paymentMethod: {},
              paymentMethodType: "free",
              billingDetails: {
                ...billingInfo.value,
                phone: shippingInfo.value.phone,
              },
              email: this.email,
            });
          }
        } catch (error) {
          const err =
            error instanceof Error
              ? error
              : new Error(error?.message || JSON.stringify(error));
          datadogLogError(err, {
            userInfo: this.userInfo,
            billingInfo: billingInfo,
            shippingInfo: shippingInfo,
            email: this.email,
          });
          console.log("error in creating payment method", error);
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    // Handle change in shipping method selection
    /**
     * handleShippingMethodChange:
     * Purpose: Handles user selection of shipping method.
     * Details: Sets loading state and emits selected method and email to parent.
     */
    handleShippingMethodChange(newValue) {
      this.hasShippingAddressError = false;
      // this.$store.dispatch(
      //   "stripeCheckout/setShippingInformationSubmittingLoading",
      //   true
      // );
      this.$emit("shippingMethodChanged", {
        method: newValue,
        email: this.email,
      });
    },

    getPaymentMethod() {
      return this.stripe.createPaymentMethod({
        elements: this.elements,
      });
    },
    scrollToError(errorCode) {
      let target = null;

      switch (errorCode) {
        case "incomplete_email":
          target = this.$refs.linkAuthElement;
          break;

        case "incomplete_number":
        case "incomplete_cvc":
          target = this.$refs.paymentElement;
          break;

        case "incomplete_first_name":
        case "incomplete_last_name":
        case "incomplete_address":
        case "empty_phone_number":
          target = this.$refs.shippingAddressElement; // all point to same section
          break;

        // case "incomplete_shipping_method":
        //   target = this.$refs.shippingMethods;
        //   break;

        default:
          target = null;
      }

      if (target) {
        this.$nextTick(() => {
          const yOffset = -100; // adjust this value as needed
          const y =
            target.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
          //target.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    },

    loadPaymentElement() {
      console.log(" load payment called");
      if (!this.paymentElement) {
        // Payment Element options
        /**
         * Stripe Payment Element:
         * Purpose: Collects payment method details (card, Apple Pay, Google Pay, etc.) in a unified UI.
         * Details: Configured with accordion layout and default billing details for demonstration.
         * Mounted to #payment-element in the template.
         */
        const paymentElementOptions = {
          layout: {
            type: "accordion",
            defaultCollapsed: false,
          },

          // defaultValues: {
          //   billingDetails: {
          //     // name: "sidharth",
          //     // email: "",
          //     // phone: "1-212-456-7890",
          //     address: {
          //       // line1: "Crane stationery",
          //       // line2: null,
          //       // city: "Crane",
          //       country: "US",
          //       // postal_code: "79731",
          //       // state: "CA",
          //     },
          //   },
          // },
        };
        // Create and mount Payment Element
        this.paymentElement = this.elements.create(
          "payment",
          paymentElementOptions
        );
        this.paymentElement.mount("#payment-element");
      }
    },
    loadShippingAddressElement() {
      if (!this.shippingAddressElement) {
        // Shipping Address Element options
        /**
         * Stripe Shipping Address Element:
         * Purpose: Collects the user's shipping address, including name, phone, and address fields.
         * Details: Configured for US addresses, split name fields, phone validation, and default values.
         * Mounted to #shipping-address-element in the template.
         */
        const shippingAddressOptions = {
          mode: "shipping",
          display: { name: "split" },
          allowedCountries: ["US", "CA"],
          contacts: this.shippingContacts,
          // defaultValues: {
          //   address: {
          //     line1: "",
          //     city: "",
          //     country: "US",
          //     postal_code: "",
          //     state: "",
          //   },
          // },
          fields: { phone: "always" },
          validation: {
            phone: {
              required: "always",
            },
          },
        };

        // Create and mount Shipping Address Element
        this.shippingAddressElement = this.elements.create(
          "address",
          shippingAddressOptions
        );
        this.shippingAddressElement.mount("#shipping-address-element");

        this.shippingAddressElement.on("change", (event) => {
          this.estimatedShippingOptions = [];
          this.hasShippingAddressError = false;
          this.shippingAddress = null;
          if (event.complete) {
            this.shippingAddressValid = true;
            let data = event.value;
            data.email = this.email;
            this.$store.dispatch(
              "stripeCheckout/setValidateShippingAddressLoading",
              true
            );
            this.validateAddressDebounced(data);
          } else {
            this.shippingAddressValid = false;
          }
        });
      }
    },
    loadBillingAddressElement(isGiftCardProduct) {
      if (!this.billingAddressElement) {
        let billingAddressOptions = {
          mode: "billing",
          display: { name: "split" },
          allowedCountries: ["US", "CA"],
          contacts: this.billingContacts,
        };
        if (isGiftCardProduct) {
          billingAddressOptions = {
            ...billingAddressOptions,
            // defaultValues: {
            //   address: {
            //     line1: "",
            //     city: "",
            //     country: "US", // US as default country
            //     postal_code: "",
            //     state: "",
            //   },
            // },
            fields: {
              phone: "always",
            },
            validation: {
              phone: {
                required: "always",
              },
            },
          };
        }

        // Create and mount Billing Address Element
        this.billingAddressElement = this.elements.create(
          "address",
          billingAddressOptions
        );
        this.billingAddressElement.mount("#billing-address-element");

        this.billingAddressElement.on("change", async (event) => {
          if (event.error) {
            this.snackbar = {
              message: event.error.message,
              color: "error",
              show: true,
              timeout: 3000,
            };
          }
        });
      }
    },
    clearPaymentElement() {
      console.log(" destroy payment called");
      if (this.paymentElement) {
        this.paymentElement.destroy();
        this.paymentElement = null;
      }
    },
    clearBillingAddressElement() {
      if (this.billingAddressElement) {
        this.billingAddressElement.destroy();
        this.billingAddressElement = null;
      }
    },
    clearShippingAddressElement() {
      if (this.shippingAddressElement) {
        this.shippingAddressElement.destroy();
        this.shippingAddressElement = null;
      }
    },
    // setShippingAddressDebounced: debounce(function (data) {
    //   this.estimatedShipping = "";
    //   this.shippingAddress = data.address;
    //   this.$emit("setShippingAddress", data);
    // }, 1500),
    validateAddressDebounced: debounce(function (data) {
      this.$emit("validateShippingAddress", data);
    }, 1500),
    emitOpenSign() {
      this.$emit("open-sign", this.subscribeToNewsletter);
    },
    checkGuestCouponCode(data) {
      this.$emit("checkGuestCouponCode", data);
    },
    removeGuestCouponCode(data) {
      this.$emit("removeGuestCouponCode", data);
    },
    checkUserCouponCode(data) {
      this.$emit("checkUserCouponCode", data);
    },
    removeUserCouponCode(item) {
      this.$emit("removeUserCouponCode", item);
    },
    userSelectedAddress(data) {
      this.estimatedShipping = null;
      this.hasShippingAddressError = false;
      this.shippingAddress = null;
      this.estimatedShippingOptions = [];
      if (data) {
        this.shippingAddress = data.address;
        this.$emit("setShippingAddress", data);
      }
    },
    handleUseStoreCreditClick() {
      this.$emit("useStoreCredit");
    },
  },
  created() {
    // Set initial loading state for Stripe Elements
    this.stripeElementsLoading = true;
  },
};
</script>
<style lang="scss">
.stripe-overlay-wrapper {
  position: relative;
  min-height: 900px;
}

.stripe-skeleton-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  /* z-index: 10; */
  transition: opacity 0.1s ease;
}
.stripe-skeleton-overlay.fade-out {
  opacity: 0;
  pointer-events: none;
  /* display: none; */
}

.stripe-container {
  opacity: 0;
  transition: opacity 0.1s ease;
}

.stripe-container.stripe-ready {
  opacity: 1;
}
.stripe-input .v-field__input {
  border: 1px solid #e6e6e6;
  background-color: #fff;
  border-radius: 5px;
  padding: 12px;
  height: 45px;
}

body:has(.stripe-skeleton-overlay:not(.fade-out)) {
  overflow: hidden;
}

.already-register-container {
  position: absolute;
  top: 44px;
  right: 20px;
  z-index: 99;
  font-size: 14px;
}
.stripe-container .warning {
  color: #d08700;
}

.stripe-container .border-error {
  border-color: #df1b41 !important;
  box-shadow: 0px 0px 0px 3px #fafafa !important;
}
.stripe-container .text-error {
  color: #df1b41 !important;
}
.shipping-option {
  border: 1px solid #dfdfdf;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
}

.shipping-option.selected-shipping {
  background: #d9e3f6 !important;
  border: 1px solid #0f162a;
  font-weight: 700;
  box-shadow: none;
}
.checkout-radio {
  .v-selection-control__wrapper {
    width: 24px;
    height: 24px;
    align-items: center;
  }
  .v-input--selection-controls__input,
  .v-selection-control__input {
    width: 16px !important;
    height: 16px !important;
    min-width: 16px !important;
    min-height: 16px !important;
    box-sizing: border-box;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    margin-bottom: 0.5px;
  }
  .v-selection-control__ripple .v-icon {
    font-size: 10px !important; /* inner dot = ~10px (tweak if needed) */
    line-height: 1;
    width: 10px !important;
    height: 10px !important;
  }
  &:hover,
  &:active,
  &.v-input--is-focused {
    .v-input--selection-controls__input {
      width: 16px !important;
      height: 16px !important;
    }
  }
  .v-ripple__animation,
  .v-ripple__container {
    width: 16px !important;
    height: 16px !important;
    overflow: hidden;
  }

  .v-icon {
    width: 16px;
    height: 16px;
  }
  /* if label spacing shifts because of new width, adjust label margin */
  .v-label {
    margin-left: 8px; /* tune as needed */
  }
}
</style>
